import axios from "axios";
import { handlerError } from "utils";
import { notification } from 'antd';


export const getAllManagerBenefit = async (user = null, company = null) => {
    try {
        const res = await axios.get(`/benefit/manager`, { params: { user: user, company: company } });
        return res.data.managers && res.data.managers.length > 0 ? res.data.managers : [];
    } catch (ex) {
        handlerError(ex);
        return [];
    }
}

export const saveBenefitManager = async (benefit, manager) => {
    try {
        await axios.post(`/benefit/manager`, { benefit, manager });
        notification.success({
            message: "Gerente inserido a segmentação com sucesso!",
        })
    } catch (ex) {
        handlerError(ex);
        return {};
    }
}

export const removeBenefitManager = async (benefit, manager) => {
    try {
        await axios.delete(`/benefit/manager`, { params: { benefit, manager } });
        notification.success({
            message: "Gerente de segmentações removido com sucesso!",
        })
    } catch (ex) {
        handlerError(ex);
        return {};
    }
}

export const updateBenefitManager = async (managerBranch, benefit, manager) => {
    try {
        await axios.post(`/benefit/manager/managerBranch`, { benefit, manager, managerBranch: managerBranch });
        notification.success({
            message: "Gerente de segmentações atualizado com sucesso!",
        })
    } catch (ex) {
        handlerError(ex);
        return {};
    }
}